import { render, staticRenderFns } from "./invoiceConfig.vue?vue&type=template&id=06df018e&scoped=true"
import script from "./invoiceConfig.vue?vue&type=script&lang=js"
export * from "./invoiceConfig.vue?vue&type=script&lang=js"
import style0 from "./invoiceConfig.vue?vue&type=style&index=0&id=06df018e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06df018e",
  null
  
)

export default component.exports